import { useEffect} from "react";
import ReactGA from "react-ga";

const useGaPageView = ({gaTitle, gaLocation }) => {
  useEffect(() => {
    if (gaTitle && gaLocation) {
      ReactGA.pageview(gaLocation, null, gaTitle);
    }
  }, [gaTitle, gaLocation]);
};

export default useGaPageView;